import {BehaviorSubject, pairwise, startWith} from 'rxjs';
import NoDataIndicator from './no_data_indicator';

export default class AbstractChart {
  constructor() {
    this.subscribes = [];
    this.filterSubject = new BehaviorSubject([]);
    this.noDataIndicator = new NoDataIndicator();
  }

  toSplitCustomDate(filter, param) {
    if (!filter.value.includes('custom')
        && !filter.value.includes('dated_at_before')
        && !filter.value.includes('dated_at_after')) {
      return;
    }
    filter.value.split('&').forEach(function(queryStr, index) {
      if (index === 0) {
        // dated_at=custom
        param[filter.key] = queryStr;
        return;
      }
      const queryArr = queryStr.split('=');
      param[queryArr[0]] = queryArr[1];
    });
  }

  toParamFilter(filters) {
    const param = {};
    filters.filter(f => f.active).forEach(f => {
      if (param[f.key]) {
        param[f.key].push(f.value);
      } else {
        if (f.key === 'dated_at' && f.value.startsWith('custom')) {
          this.toSplitCustomDate(f, param);
        } else {
          param[f.key] = [f.value];
        }
      }
    });
    return param;
  }

  toParamSort(sort) {
    const param = {};
    Object.keys(sort).forEach((k) => {
      param['sort'] = k;
      param['order'] = sort[k];
    });
    return param;
  }

  renderFilterButtons($filter_block, $button_tmpl, afterRenderFn = null) {
    const is_filter_disabled = $filter_block.hasClass('disabled');
    // Read wrap-up configuration from data attributes
    const show_wrap_up_filter = $filter_block.data('show-wrap-up-filter') == '1'; // Use == to handle both string and number
    const wrap_up_year = $filter_block.data('wrap-up-year');

    this.subscribes.push(
      this.filterSubject.pipe(startWith(null), pairwise()).subscribe(([prev, filters]) => {
        // Filter and update wrap_up_year filter based on configuration
        let processedFilters = filters.map(f => {
          if (f.key === 'dated_at' && f.value === 'wrap_up_year') {
            // Update label with year if wrap-up is enabled
            if (show_wrap_up_filter && wrap_up_year) {
              return {...f, label: `${wrap_up_year} Wrap-Up`};
            }
          }
          return f;
        });

        // Remove wrap_up_year filter if not in display period
        if (!show_wrap_up_filter) {
          processedFilters = processedFilters.filter(f => !(f.key === 'dated_at' && f.value === 'wrap_up_year'));
        }

        $filter_block.html($button_tmpl.render({
          filter_buttons: processedFilters.filter(_ => _.position === 'filter'),
          mal_filter_buttons: processedFilters.filter(_ => _.position === 'mal_filter'),
          categories: processedFilters.filter(_ => _.position === 'category'),
          disabled: is_filter_disabled
        }));
        if (afterRenderFn) {
          afterRenderFn([prev, processedFilters]);
        }
      }));
    $filter_block.on('click mal-select-value mal-picker-value', 'button', ({e, currentTarget}) => {
      const key = currentTarget.dataset.filterKey;
      const value = currentTarget.dataset.filterValue;
      const active = currentTarget.classList.contains('active');

      if (key === 'dated_at' && value.includes('custom') && !currentTarget.dataset.datedAtBefore) {
        // Date PickerではClickではなくChange Eventで変更するため、何もしない
        return;
      }
      const filters = this.filterSubject.value.map((filter) => {
        if (filter.key === key && filter.value === value) {
          filter = {...filter, active: !active};
        } else if (filter.key === key && filter.value !== value && filter.type === 'select') {
          filter = {...filter, value, active: value > 0};
        } else if (filter.key === key && filter.value !== value && filter.type === 'check') {
          filter = {...filter, active: false};
        } else if (filter.key === key && filter.value !== value && filter.type === 'picker') {
          if (value === 'past_year' || value === 'season' || value === 'last_season' || value === 'wrap_up_year') {
          // 排他制御のため、Date Pickerをキャンセルする
            filter = {...filter, value: 'custom', label: 'Custom Time', active: false};
          } else {
            let new_value = value;
            let new_label = filter.label;
            let is_active = !active;
            if (value === 'cancel') {
              new_value = 'custom';
              new_label = 'Custom Time';
              is_active = false;
            }
            if (currentTarget.dataset.datedAtBefore) {
              new_label = currentTarget.dataset.datedAtBefore + ' - ' + currentTarget.dataset.datedAtAfter;
              is_active = true;
            }
            filter = {...filter, value: new_value, label: new_label, active: is_active};
          }
        }
        return filter;
      });
      const radio_filters = filters.filter(f => f.type === 'radio');
      if (radio_filters.length > 0 && radio_filters.filter(f => f.active).length === 0) {
        return;
      }
      this.filterSubject.next(filters);
    });
  }
}
